import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import HikingIcon from '@mui/icons-material/Hiking';
import SpaIcon from '@mui/icons-material/Spa';
import PsychologyIcon from '@mui/icons-material/Psychology';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const modalityIconMap = {
  STRENGTH: FitnessCenterIcon,
  CARDIO: DirectionsRunIcon,
  MOBILITY: SelfImprovementIcon,
  SPORT: SportsSoccerIcon,
  LIFESTYLE: HikingIcon,
  REST_RECOVERY: SpaIcon,
  MIND_BODY: PsychologyIcon,
  OTHER: HelpOutlineIcon,
};

const defaultIcon = HelpOutlineIcon;

/**
 * Returns the corresponding MUI Icon component for a given modality.
 * @param {string} modality - The modality string (e.g., 'STRENGTH').
 * @returns {import('@mui/material').SvgIconComponent} The icon component or a default icon.
 */
export const getModalityIcon = (modality) => {
  return modalityIconMap[modality] || defaultIcon;
};

export default modalityIconMap;